export default __webpack_public_path__ + "static/media/sorekt Dark mode.16af7a43.png";